<template>
  <div v-if="formattedRecipients.length">
    <div>
      {{ getRecipientString(formattedRecipients[0]) }}
    </div>
    <template v-if="showExpandButton">
      <template v-if="expanded">
        <div v-for="group in formattedRecipients.slice(1)" :key="group">
          {{ group }}
        </div>
      </template>
      <a href="#" @click.prevent.stop="expanded = !expanded">
        {{
          $t(`components.messageRecipient.actions.${expanded ? 'collapse' : 'expand'}Recipients`)
        }}
      </a>
    </template>
  </div>
</template>

<script>
export default {
  name: 'MessageRecipients',

  props: {
    recipients: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      expanded: false,
    };
  },

  computed: {
    formattedRecipients() {
      const recipients = [];
      Object.keys(this.recipients).forEach((type) => {
        if (this.recipients[type].length) {
          const items = this.recipients[type]
            .filter((item) => item.title || item.name)
            .map((item) => item.title || item.name);
          if (!items.length) {
            return;
          }
          recipients.push(
            `${this.$t(`components.messageRecipient.types.${type}`)}: ${items.join(', ')}`
          );
        }
      });

      return recipients;
    },

    showExpandButton() {
      if (this.formattedRecipients.length > 1) {
        return true;
      }

      for (let i = 0; i < this.formattedRecipients.length; i += 1) {
        if (this.formattedRecipients[i].indexOf(',') > -1) {
          return true;
        }
      }

      return false;
    },
  },

  methods: {
    getRecipientString(recipient) {
      const separatorIndex = recipient.indexOf(',');

      if (this.expanded || separatorIndex === -1) {
        return recipient;
      }

      return `${recipient.slice(0, separatorIndex)}...`;
    },
  },
};
</script>
